import { z } from "zod";

export const quoteReplacementSchema = z.object({
	originalQuoteId: z.number(),
	newQuoteId: z.number(),
	message: z.string(),
	wasOriginalInErrorState: z.boolean(),
});

export type QuoteReplacement = z.infer<typeof quoteReplacementSchema>;
